/**
 * Menu do admin no padrão do menu lateral do cliente (nov/2026): usava as classes
 * do Bootstrap (links azuis #0D6EFD, fundo #212529, ícones sem a fonte carregada)
 * e um dropdown de exemplo, sem ação, com a foto de outra pessoa.
 */
import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  BsActivity,
  BsHouseFill,
  BsPeopleFill,
  BsReceipt,
  BsShopWindow,
  BsTools,
} from 'react-icons/bs';

import useUser from 'hooks/useUser';
import { SidebarLink } from 'components/sidebar-menu/sidebar-menu.styles';

import {
  BackLink,
  SidebarBrand,
  SidebarContainer,
  SidebarNav,
  SidebarUser,
} from './sidebar.styles';

const ITEMS = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: <BsHouseFill /> },
  { to: '/admin/clientes', label: 'Clientes', icon: <BsPeopleFill /> },
  { to: '/admin/faturamento', label: 'Faturamento', icon: <BsReceipt /> },
  { to: '/admin/uso-contas', label: 'Uso das contas', icon: <BsActivity /> },
  { to: '/admin/servicos', label: 'Serviços & Parceiros', icon: <BsTools /> },
  { to: '/admin/marketplace', label: 'Marketplace', icon: <BsShopWindow /> },
];

export const Sidebar = () => {
  const { currentUser } = useUser();
  const { pathname } = useLocation();

  return (
    <SidebarContainer className="col-auto col-md-3 col-xl-2">
      <SidebarBrand to="/dashboard">EnergyPass Admin</SidebarBrand>
      <SidebarNav aria-label="Menu do admin">
        {ITEMS.map((item) => {
          const active = pathname.startsWith(item.to);
          return (
            <SidebarLink
              key={item.to}
              to={item.to}
              className={active ? 'active' : undefined}
              aria-current={active ? 'page' : undefined}
            >
              {item.icon}
              <span className="d-none d-sm-inline">{item.label}</span>
            </SidebarLink>
          );
        })}
      </SidebarNav>
      <SidebarUser>
        <span>{currentUser?.name || 'Admin'}</span>
        <BackLink to="/dashboard">Voltar ao painel</BackLink>
      </SidebarUser>
    </SidebarContainer>
  );
};
